// User Login / Sign In page.
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'

import {
  Container,
  Grid,
  Button,
  Typography,
  Link,
  Checkbox,
  FormControlLabel,
  TextField,
  Card,
  Avatar,
  InputAdornment,
  IconButton
} from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { Link as RouterLink } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { login, authDefault, googleLogin } from '../redux/actions/index'
import google from '../static/google.png'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(24),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3, 5)
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(2, 0)
  }
}))

var url = ''

export default function SignIn (props) {
  const classes = useStyles()
  const auth = useSelector(state => state.authReducer)
  const [close, setClose] = useState(false)

  const dispatch = useDispatch()
  var homeURL = `${window.location.protocol}\\\\${window.location.host}/`

  useEffect(() => {
    const query = new URLSearchParams(props.location.search)
    if (query.get('logout')) {
      localStorage.removeItem('esim_token')
    }
  // eslint-disable-next-line
  }, [])

  useEffect(() => {
    dispatch(authDefault())
    document.title = 'Login'

    const user = localStorage.getItem('username')
    if (user && user !== '') {
      setUsername(user)
      setRemember(true)
    }

    const query = new URLSearchParams(props.location.search)
    if (query.get('close')) {
      setClose(true)
    }

    const ardUrl = localStorage.getItem('ard_redurl')
    if (ardUrl && ardUrl !== '') {
      url = ardUrl
    } else if (props.location.search !== '') {
      url = query.get('url')
      localStorage.setItem('ard_redurl', url)
    } else {
      url = ''
    }
  }, [dispatch, props.location.search, close])

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => setShowPassword(!showPassword)
  const handleMouseDownPassword = () => setShowPassword(!showPassword)

  // Function call for normal user login.
  const handleLogin = (event) => {
    event.preventDefault()
    if (remember) {
      localStorage.setItem('username', username)
    } else if (username === localStorage.getItem('username')) {
      localStorage.setItem('username', '')
    }
    if (!close) {
      dispatch(login(username, password, url))
    }
    if (close) {
      dispatch(login(username, password, 'close'))
    }
    localStorage.removeItem('ard_redurl')
  }

  // Function call for google oAuth login.
  const handleGoogleLogin = () => {
    var host = window.location.protocol + '//' + window.location.host
    dispatch(googleLogin(host))
  }

  return (
    <Container component="main" maxWidth="xs">
      <Card className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>

        <Typography component="h1" variant="h5">
          Login | Sign In
        </Typography>

        {/* Display's error messages while logging in */}
        <Typography variant="body1" align="center" style={{ marginTop: '10px' }} color="error" >
          {auth.errors}
        </Typography>

        <form className={classes.form} onSubmit={handleLogin} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Username"
            name="email"
            autoComplete="email"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={'Show Password'} aria-label={'Show Password'} arrow>
                    <IconButton
                      size="small"
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />} {/* handle password visibility */}
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
            }}
            type={showPassword ? 'text' : 'password'}
            id="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <FormControlLabel
            control={
              <Checkbox
                value="remember"
                checked={remember}
                onChange={ () => { setRemember(!remember) }}
                color="primary" />
            }
            label="Remember me"
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            // onClick={handleLogin}
            className={classes.submit}
          >
            Login
          </Button>
          <Grid container>
            <Grid item xs>
              <Link component={RouterLink} to="/reset-password" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link component={RouterLink} to="/signup" variant="body2">
                {'New User? Sign Up'}
              </Link>
            </Grid>
          </Grid>
        </form>
        <Typography variant="body1" color="secondary" align="center" >Or</Typography>

        {/* Google oAuth Sign In option */}
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={handleGoogleLogin}
          className={classes.submit}
        >
          <img alt="G" src={google} height="20" />&emsp; Login With Google
        </Button>
      </Card>
      <Button
        onClick={() => { window.open(homeURL, '_self') }}
        fullWidth
        color="default"
        className={classes.submit}
      >
        Back to home
      </Button>
    </Container>
  )
}
